module.exports = __webpack_public_path__ + "img/mh4.c755228c.jpg";